export { GovernTenantApiService } from "./tenant.service";
export { FloorApiService } from "./floor.service";
export { GovernTenantCategoryApiService } from "./tenant-category.service";
export { GovernTenantFnbCategoryApiService } from "./govern-tenant-fnb-category.service";
export { FnbProductCategoryApiService } from "./fnb-product-category.service";
export {
  FnbProductApiService,
  FnbProductApiItem,
  FindFnbProductDto,
} from "./fnb-product.service";
export { AdminBannerHomeService } from "./admin-banner-home.service";
export { MallPublicService } from "./mall-public.service";
export { OfflineTenantVoucherService } from "./offline-tenant-voucher.service";
export { MallFacilityApiService } from "./facility-booking.service";
export { AdminManageQaService } from "./admin-manage-qa.service";
export { GovernTableApiService } from "./table.service";
export {
  PaymentMethodApiService,
  PaymentMethodDto,
} from "./payment-method.service";
export { OfflineTenantOrderingApiService } from "./offline-tenant-ordering.service";
export { FnbOrderApiService } from "./fnb-order.service";

// Stamp Collection (FR-01 → FR-09)
export { AdminChallengeService } from "./admin-challenge.service";
export { AdminChallengeConfigService } from "./admin-challenge-config.service";
// Lớp join field BE không trả (milestonePosition / milestoneType / discountType)
export {
  AdminChallengeMilestoneIndexService,
  MilestoneIndexEntry,
  RewardOptionIndexEntry,
} from "./admin-challenge-milestone-index.service";
export { AdminStampRequestService } from "./admin-stamp-request.service";
export {
  AdminStampHistoryService,
  StampHistoryExportResponseDto,
} from "./admin-stamp-history.service";
export { AdminRewardHistoryService } from "./admin-reward-history.service";
